import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-20 d-sm-flex align-items-center justify-content-between letter-spacing" }
const _hoisted_2 = { class: "mb-5 mb-sm-0 fw-bold" }
const _hoisted_3 = { class: "mb-20 d-sm-flex align-items-center justify-content-between letter-spacing" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "chartPerformance",
    class: "chart"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.Lang), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("small", null, _toDisplayString(_ctx.graph.yLabel), 1)
    ]),
    _hoisted_4
  ], 64))
}